import { render } from "./result.vue?vue&type=template&id=596d03a0&scoped=true"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"

import "./result.vue?vue&type=style&index=0&id=596d03a0&scoped=true&lang=css"
import "./result.vue?vue&type=style&index=1&id=596d03a0&lang=scss"
import "./result.vue?vue&type=style&index=2&id=596d03a0&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596d03a0"]])

export default __exports__